import { Translator } from '~domain/i18n';
import { LanguageId } from '~domain/model/core/supported-languages';

export async function changeAppLanguage(lngId: LanguageId, translator: Translator) {
  // Change language
  await translator.changeTranslatorLanguage(lngId);

  // Reload page
  window.location.reload();
}
